import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Messages } from 'src/app/constants/messages';
import {
  ButtonColor,
  ButtonLabelPosition,
  ButtonModel,
  ButtonOption,
  ButtonType,
  DataBroadcast,
  DialogExtrasModel,
  DialogModel
} from 'src/app/model';
import { DataService } from 'src/app/services';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  closeAction: ButtonModel = {
    label: Messages?.BUTTON_LABEL_CLOSE,
    type: ButtonType?.BUTTON,
    value: false
  };

  readonly BUTTON_TYPE = ButtonType;
  readonly BUTTON_LABEL_POSITION = ButtonLabelPosition;
  readonly BUTTON_OPTION = ButtonOption;
  readonly BUTTON_COLOR = ButtonColor;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModel,
    private _dataService: DataService
  ) { }
  
  /**
   * Determines whether button click on
   * @param action
   * @param [extras]
   */
  onDialogButtonClick(event: MouseEvent, selAction: ButtonModel, extras?: DialogExtrasModel) {
    if (selAction?.type === ButtonType?.BUTTON) {
      this.dialogRef?.close(selAction?.value ?? false);
    }
    this._dataService?.broadcast(
      DataBroadcast.DIALOG_BROADCAST,
      {
        type: selAction?.type,
        actionType: selAction?.action,
        extras
      }
    );
  }

  /**
   * Determines whether close dialog on
   * @param type
   * @param dialogRef
   */
  onDialogClose(type: boolean, dialogRef: MatDialogRef<DialogComponent>) {
    dialogRef?.close(type);
  }
}
